import store from '@/store/index'
import { ENGINEER_DASHBOARDS, ENGINEER_DASHBOARD_ROUTE } from '@/utils/locale'
import { aclHelper } from './aclHelper'

export const dashboardAccessMap = {
  hasCmsAccess: ENGINEER_DASHBOARD_ROUTE.CMS,
  hasTmsAccess: ENGINEER_DASHBOARD_ROUTE.TMS,
  hasWpAccess: ENGINEER_DASHBOARD_ROUTE.WP,
}

export function bShowModConfiguredOption (code) {
  switch (code) {
    case ENGINEER_DASHBOARDS.CMS:
      return this.enableTenderFeature || this.enableProjectFeature
    case ENGINEER_DASHBOARDS.TMS:
      return this.enableTenancyRecordsFeature
    case ENGINEER_DASHBOARDS.WP:
      return this.enableWorkPermitsFeature
    default:
      return false
  }
}

export function hasCmsDashboardAccess () {
  const enableProjectFeature = store.getters['regions/enableProjectFeature']
  const enableTenderFeature = store.getters['regions/enableTenderFeature']
  const enableFeatures = enableProjectFeature || enableTenderFeature
  return enableFeatures && (aclHelper.hasProjectsAccess() || aclHelper.hasTendersAccess() || aclHelper.hasTenderRepAccess())
}

export function hasTmsDashboardAccess () {
  const enableProjectFeature = store.getters['regions/enableTenantProjectsFeature']
  const enableTenderFeature = store.getters['regions/enableDirectoryFeature']
  const enableFeatures = enableProjectFeature || enableTenderFeature
  return enableFeatures && aclHelper.showTmsDashboard()
}

export function hasWpDashboardAccess () {
  const enableWorkPermitsFeature = store.getters['regions/enableWorkPermitsFeature']
  return enableWorkPermitsFeature && aclHelper.showWorkPermitDashboard()
}

/**
 * @template
 * @param {keyof ENGINEER_DASHBOARD_ROUTE} defaultDashboard
 * @param {Record<keyof dashboardAccessMap, function>} accessFnMap
*/
export function getDashboard (defaultDashboard, accessFnMap = {}) {
  const allowedDashboard = []
  for (const [key, value] of Object.entries(dashboardAccessMap)) {
    const accessFn = accessFnMap[key]
    if (accessFn()) {
      allowedDashboard.push(value)
    }
  }
  const dashboard = ENGINEER_DASHBOARD_ROUTE[defaultDashboard] || ENGINEER_DASHBOARD_ROUTE.CMS
  let result = null
  if (allowedDashboard.length && !allowedDashboard.includes(dashboard)) {
    result = allowedDashboard[0]
  } else {
    result = dashboard
  }
  return result
}
